import { render, staticRenderFns } from "./chooseGenderDialog.vue?vue&type=template&id=39c5d174"
import script from "./chooseGenderDialog.vue?vue&type=script&lang=js"
export * from "./chooseGenderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports